import React, { Component } from 'react';
import { SiteInfo } from '../content/info'
import FontAwesome from 'react-fontawesome'

class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false
    }
  }

  render() {
    return (
      <div className="about" >
        <div className="about-desc">
          <div className="photos">
            {SiteInfo.photos.map((photo)=> {
              return (
                <div className="photo-wrapper" style={{ backgroundColor: photo.bgColor }}>
                  <div className="personal__photo" style={{ backgroundImage: `url(${photo.url})` }}>
                  </div>
                </div>
              )
            })}
          </div>
          {SiteInfo.about.split('\n\n').map((par, index)=> {
            return (
              <p>{index === 0 ? <span className="intro">Hi, I'm Melissa. </span>:''}{par}</p>
            )
          })}
          <div className="about-icons">
            {SiteInfo.links.map((link)=> {
              return (
                <span>
                  <a href={link.val} target="_blank">
                    <FontAwesome name={link.icon} size="2x" />
                  </a>
                </span>
              )
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/about.js